import styled from 'styled-components';

interface IRootProps {
  widthValue?: string;
  heightValue?: string;
  backgroundColor?: string;
}

export const Root = styled.div`
  width: ${(props: IRootProps) => (props.widthValue ? props.widthValue : `100vw`)};
  height: ${(props: IRootProps) => (props.heightValue ? props.heightValue : `100vh`)};
  background-color: ${(props: IRootProps) => (props.backgroundColor ? props.backgroundColor : `#000000BB`)};
  position: relative;
  display: block;
  overflow: hidden;
`

export const PreviewsConstructorContainer = styled.div`
  position: fixed;
  top: 400px;
  left: 400px;
  transform: scale(0.2);
  z-index: 1000;
  display: none;
`

export const MainCanvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  display: none;
`

export const EditorContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`

export const LayerNamesContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  width: 350px;
  padding: 10px;
  overflow-Y: auto;
  overflow-X: hidden;
`

export const ZoomContainer = styled.div`
  width: ${(props: IRootProps) => (props.widthValue ? props.widthValue : `calc(100% - 350px)`)};
  height: 100%;
  background-color: ${(props: IRootProps) => (props.backgroundColor ? props.backgroundColor : `#00000090`)};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: scroll;
  position: relative;
`

export const CanvasLayerBackground = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const BackgroundSpace = styled.div`
  width: 100%;
  height: 100%;
  background-color: #00000090;
`

export const SectionOptionContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  display: flex;
  z-index: 300;
`

export const SectionOption = styled.div`
  width: 80px;
  height: 33px;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 12px;
`

export const ArtboardOptionContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 390px;
  display: flex;
  z-index: 300;
`

export const ArtboardOption = styled.div`
  width: 80px;
  height: 33px;
  color: white;
  cursor: pointer;
  background-color: #0000ff90;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 12px;
`

export const ExportButton = styled.div`
  width: 80px;
  height: 33px;
  color: white;
  cursor: pointer;
  background-color: blue;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin: 0px 0px 0px 15px;
`